import React from "react";
import { motion } from "framer-motion";

const EASE = [0.76, 0, 0.24, 1];

// Word/line-by-line masked reveal for headings
export const LineReveal = ({ lines, className = "", delay = 0 }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="reveal-mask">
        <motion.span
          className="block"
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 0.9, ease: EASE, delay: delay + i * 0.12 }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

// Scroll-triggered fade + rise
export const Reveal = ({ children, className = "", delay = 0, y = 40 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);

export const Marquee = ({ items, className = "" }) => (
  <div className={`overflow-hidden ${className}`}>
    <div className="marquee-track">
      {[...items, ...items].map((it, i) => (
        <span key={i} className="mx-8 inline-flex items-center gap-8">
          <span>{it}</span>
          <span className="text-[var(--accent)]">✳</span>
        </span>
      ))}
    </div>
  </div>
);
